import React, { useState, useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import PropTypes from "prop-types";
import { useForm } from "react-hook-form";
import { connect } from "react-redux";
import { IoMdArrowBack } from "react-icons/io";
import { IoMdClose } from "react-icons/io";
import { withTranslation } from "react-i18next";
import { Signup, ClearState } from "../../actions/productActions";
import PopUp from "../Modals/Popup";
import SignupComplete from "./SignupComplete";
import { checkEmail, clearUserState, signup, tempSignupData } from "../../actions/userActions";
import close from "../../assets/svgs/close.svg";
import warley from "../../assets/svgs/warley.svg";
import "../../assets/css/form.css";
import "../../assets/css/component.css";
import "./signup.css";
import "../../assets/css/modal.css";
import { loginUser } from "../../actions/authActions";

const Signup2 = (props) => {
  const { register, reset, handleSubmit } = useForm();
  const [canSubmit, setSubmitState] = useState(false);
  const [load, setLoad] = useState(false);
  const [lshow, setLshow] = useState(false);
  const [popupText, setPopupText] = useState("");
  const [emailStatus, setEmailStatus] = useState("ERROR");
  const [emailText, setEmailText] = useState("");
  const emailInputElement = useRef(null);
  const [accountSuccess, setShowModal] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [userSignUp, setUserSignUp] = useState();

  useEffect(() => {
    if (props.signup && !props.loading && props.signup.success && load) {
      console.log("____Not Errors______");
      setLoad(false);
      localStorage.removeItem('cart');
      setPopupText("Registration Successfully!");
      setLshow(true);
      reset();
      //props.closeModal();
      props.ClearState();
    } else if (props.errors && load) {
      alert(JSON.stringify(props.errors.data));
      setLoad(false);
      props.ClearState();
    }
  }, [load, props]);

  useEffect(() => { //USED TO CHECK IF EMAIL INPUT ELEMENT HAS CHANGED
    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    setSubmitState(false)
    setEmailStatus("")
    props.clearUserState()
    if (emailRegex.test(String(emailText).toLowerCase())) {
      setEmailStatus(<div className="footer-warley-description text-dark">Loading</div>)
      props.checkEmail(emailText) //SEND THE REQUEST TO CHECK EMAIL
    }
  }, [emailText])

  useEffect(() => { //USED TO CHECK IF SIGNUP WAS SUCCESSFUL
    if (props?.user?.signup?.data?.success) {
      setShowModal(true);
      props.clearUserState();
    }
  }, [props.user.signup]);


  useEffect(() => { // USED TO UPDATE ERROR/SUCCESS MESSAGE FOR EMAIL
    if (props.user.email === true) {
      setEmailStatus(<div className="footer-warley-description text-success">Email Available</div>)
    } else if (props.user.email === false) {
      setEmailStatus(<div className="footer-warley-description text-danger">Email already Exist</div>)
    }
  }, [props.user.email])

  //signup
  const onSubmit = (data) => {
    if (data.password !== data.confirm_password) {
      setConfirmPassword("Password must be the same");
      return;
    }

    let newData = {
      ...props.signupVal,
      ...data,
      email: emailInputElement.current.value,
      password: data.password,
      confirm_password: data.confirm_password,
      location_id: props.location_id || localStorage.location_id,
      business_id: props.business_id || localStorage.business_id,
      username: props.signupVal.first_name
    };

    props.setSignup(newData);
    props.tempSignupData(newData);
    props.signup(newData); // SEND REQUEST TO SIGN UP
  };

  useEffect(() => {
    if (props?.user?.signup?.data?.success) {
      props.closeModal();
    } else if (props?.user?.signup?.data?.message) {
      toast.error(props.user.signup.data.message);
    }
  }, [props?.user?.signup]);


  const closeModal = () => {
    props.closeModal();
    setLshow(false);
  };

  if (document.querySelector("#signUpButton")) { //Check if not null
    if (!props.user?.email || props.user?.checkEmailLoading) {
      document.querySelector("#signUpButton").style.opacity = 0.5
      document.querySelector("#signUpButton").disabled = true
    } else {
      document.querySelector("#signUpButton").style.opacity = 1.0
      document.querySelector("#signUpButton").disabled = false
    }
  }

  const handleBack = () => {
    props.previousStep();
  }

  useEffect(() => {
    if (props.signup_login) {
      const userData = {
        email: props.signup_login?.data.user.email,
        password: props.tempSignupResults?.password || "test123",
        platform: "Food-Delivery",
        business_id: props.business_id || localStorage.business_id,
        username: props.auth.username
      }
      props.loginUser(userData, true, "register");
    }

  }, [props.signup_login]);

  return (
    <>
      <SignupComplete
        joinus={props.joinus}
        location_id={props.location_id}
        business_id={props.business_id}
        show={accountSuccess}
        closeModal={() => { setShowModal(false) }}
        signup_login={userSignUp?.data}
        user_name={props.auth.username}
      />
      <Modal
        show={props.show}
        onHide={props.joinus ? () => { } : props.closeModal}
        dialogClassName="modal-md xs"
        contentClassName="xs"
        centered
      >
        <PopUp text={popupText} show={lshow} closeModal={closeModal} />
        <form onSubmit={handleSubmit(onSubmit)} className="modal_form">
          <Modal.Body className="px-6 py-4">
            <div className="">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={
                  () => {
                    if (props.joinus) {
                      props.setSignupClose(1)
                    } else {
                      props.closeModal()
                    }
                  }
                }
              >
                {/* <img src={close} alt="close" /> */}
                <IoMdClose size={25} style={{ cursor: "pointer" }} />
              </button>
              {/* <IoMdArrowBack size={25} style={{ cursor: "pointer" }} onClick={() => props.setSignupClose(1)} /> */}
              <div onClick={handleBack}>
                <IoMdArrowBack
                  size={25}
                  style={{ cursor: "pointer" }}
                />
              </div>
            </div>
            <div className="text-center mt-5">
              <img src={warley} width="263px" height="55px" alt="warley" />
              <div className="signup-subtitle">Sign up for WARELY account</div>
              <div className="">
                <div className="input-title mb-2">Email</div>
                <div className="mb-2">
                  <input
                    type="email"
                    ref={emailInputElement}
                    className="form-control-lg input input-full"
                    required
                    autoComplete="off"
                    onChange={() => { setEmailText(emailInputElement.current.value) }}
                  />
                  <div className="">{emailStatus}</div>
                </div>
              </div>
              <div className="mt-4">
                <div className="input-title mb-2">Password</div>
                <div className="mb-2">
                  <input
                    required
                    minLength="7"
                    autoComplete="off"
                    {...register("password")}
                    type="password"
                    className="form-control-lg input input-full"
                  />
                </div>
              </div>
              <div className="mt-4">
                <div className="input-title mb-2">Confirm Password</div>
                <div className="mb-2">
                  <input
                    required
                    minLength="7"
                    autoComplete="off"
                    {...register("confirm_password")}
                    type="password"
                    className="form-control-lg input input-full"
                  />
                  <div className="footer-warley-description text-danger">{confirmPassword}</div>
                </div>
              </div>
              <div className="d-flex justify-content-center mt-4">
                <div className="footer-warley-description text-left w-100">
                  By signing up, you have read and agreed to our
                  <br />
                  <span>
                    <a
                      href="/terms-and-condition"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-danger cursor"
                    >
                      Terms & Conditions
                    </a>
                  </span>
                  &nbsp; and &nbsp;
                  <span>
                    <a
                      href="/privacy-policy"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-danger cursor"
                    >
                      Privacy Policy.
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="modal-footer">
            <button
              type="submit"
              className="btn btn-danger rounded font-weight-bold btn-block py-3 f18"
              data-dismiss="modal"
              style={{ opacity: canSubmit ? 1.0 : 0.5 }}
              id="signUpButton"
            >
              Sign up
            </button>
            <div className="powered my-4 w-100">Powered by Warely</div>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};
Signup2.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  signup: state?.products?.signup,
  loading: state?.products?.loading,
  auth: state?.auth,
  errors: state?.products?.errors,
  user: state?.user,
  signup_login: state?.user?.signup,
  tempSignupResults: state?.user?.tempSignup
});

export default withTranslation()(
  connect(mapStateToProps, { Signup, ClearState, checkEmail, clearUserState, signup, loginUser, tempSignupData })(Signup2)
);
